import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const FillRateVsEntregasBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getFillRatePurchases, dataReady } = useData();

  // Get data from Excel (3 years)
  const excelData = dataReady ? getFillRatePurchases() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Alimentos', 'Automotriz', 'Construcción', 'Manufactura', 'Retail', 'Sector salud/ Farmacéuticas', 'Servicios Logísticos'];

  const allData2022 = excelData.data2022.length > 0 ? excelData.data2022 : [91, 81, 90, 91, 96, 91, 94];
  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [97, 94, 96, 86, 86, 100, 95];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [96, 95, 96, 95, 92, 99, 95];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const getValuesForLabels = (allValues) => labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? allValues[index] : 0;
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: '2023',
        data: getValuesForLabels(allData2022),
        backgroundColor: '#A2AEBB',
      },
      {
        label: '2024',
        data: getValuesForLabels(allData2023),
        backgroundColor: '#476A8E',
      },
      {
        label: '2025',
        data: getValuesForLabels(allData2024),
        backgroundColor: '#1F3D58',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        bottom: 20,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 15,
          padding: 10,
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 9,
        },
        formatter: (value) => `${Math.round(value)}%`,
        anchor: 'end',
        align: 'top',
        offset: (context) => {
          // Stagger labels vertically to avoid overlap
          return context.datasetIndex === 0 ? 2 : context.datasetIndex === 1 ? 12 : 22;
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria',
          font: {
            size: 14,
          },
          color: '#333',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Porcentaje (%)',
          font: {
            size: 14,
          },
          color: '#333',
        },
        beginAtZero: true,
        max: 115,
        ticks: {
          stepSize: 10,
        },
      },
    },
  };

  const infoContent = {
    formulas: {
      fillRate: '(Total de piezas entregadas / Total de piezas solicitadas) × 100',
    },
    description: 'Mide la cantidad de piezas recibidas vs piezas requeridas a los proveedores, en porcentaje.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmulas:</strong></p>
          <p>Fill Rate: {infoContent.formulas.fillRate}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FillRateVsEntregasBar;
